import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import ContentBrokenCardInterface from '@/common/interfaces/modules/ContentBrokenCard';
import TitleIconComponent from '@/components/TitleIcon/TitleIcon.vue';
import ResponsiveImageRatio from '@/components/ResponsiveImageRatio/ResponsiveImageRatio.vue';
import { ImageWidths} from '@/common/interfaces/SizeBreakpoints';
import { VideoJsPlayerOptions } from 'video.js';
import VideoPlayer from '@/components/VideoPlayer/VideoPlayer.vue';
import PlayPlaceholder from '@/components/PlayPlaceholder/PlayPlaceholder.vue';
import Cross from '@/assets/icons/cross.svg?inline';
import { openModal, closeModal } from '@/utils/vueUtils';
import FocusTrapDirective from '@/directives/FocusTrapDirective';

const ContentBrokenCardProps = Vue.extend({
  props: { card: Object as () => ContentBrokenCardInterface },
});

@Component({
  components: {
    ResponsiveImageRatio,
    TitleIcon: TitleIconComponent,
    VideoPlayer,
    PlayPlaceholder,
    Cross,
  },
  directives: {
    'trap-focus': FocusTrapDirective,
  },
})
export default class ContentBrokenCard extends ContentBrokenCardProps {
  imageWidths: ImageWidths = {
    def: 463,
    sizes: {
      sm: 636,
      md: 992,
      lg: 793,
      xl: 993,
    },
  };

  imageWidthsPortrait: ImageWidths = {
    def: 360,
    sizes: {
      sm: 480,
      md: 300,
      lg: 380,
    },
  };

  modalVideoOptions: VideoJsPlayerOptions = {
    autoplay: true,
    loop: false,
    muted: false,
    controls: true,
  };

  reverseCard() {
    this.$data.rowReverse = !this.$data.rowReverse;
  }

  data() {
    return {
      rowReverse: false,
    };
  }

  openModal() {
    openModal(this.$modal, `video-player-${this.uuid}`);
  }

  closeModal() {
    closeModal(this.$modal, `video-player-${this.uuid}`);
  }
}
